import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {redirectTo} from '../../../utils';
import {getIsUserLoggedIn} from '../../../reducers/user/selectors';
import {userAuth0OmniauthAuthorizePath} from '../../../api/routes';

function LoginPage() {
  const isLoggedIn = useSelector(getIsUserLoggedIn);
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/', {replace: true});
    } else {
      redirectTo({path: userAuth0OmniauthAuthorizePath(), replace: true});
    }
  });

  return null;
}

export default LoginPage;
